import React, { FunctionComponent } from 'react';
import { TextSmall } from 'components/chroma/extended';
import { FunnelType } from 'scenes/common/flows/types';

interface QuotePriceExcessInfoProps {
  excess?: number;
  buildingExcess?: number;
  contentsExcess?: number;
  funnelType?: FunnelType;
  isBuildingCover?: boolean;
  isContentsCover?: boolean;
  thirdPartySelected?: boolean;
  comprehensiveSelected?: boolean;
  isBuildingAndContentsCover?: boolean;
}

const QuotePriceExcessInfo: FunctionComponent<QuotePriceExcessInfoProps> = ({
  excess,
  funnelType,
  buildingExcess,
  contentsExcess,
  isBuildingCover,
  isContentsCover,
  thirdPartySelected,
  comprehensiveSelected,
  isBuildingAndContentsCover,
}) => (
  <>
    {funnelType === FunnelType.Motor && (
      <>
        {thirdPartySelected && (
          <TextSmall margin={{ top: 1, bottom: 1 }}>
            * This quote is based on an excess of ${excess}.
          </TextSmall>
        )}
        {comprehensiveSelected && (
          <TextSmall margin={{ top: 1, bottom: 1 }}>
            * This quote is based on a nominated excess of ${excess}. You may
            change your premium on the next page by choosing a different
            nominated excess.
          </TextSmall>
        )}
      </>
    )}
    {(funnelType === FunnelType.Home || funnelType === FunnelType.Landlord) && (
      <>
        {isBuildingAndContentsCover && (
          <TextSmall margin={{ top: 1, bottom: 1 }}>
            * This quote is based on nominated excesses of ${buildingExcess} for
            Building and ${contentsExcess} for Contents. You can change your
            premium on the next pages by choosing different nominated excesses.
          </TextSmall>
        )}
        {(isBuildingCover || isContentsCover) && (
          <TextSmall margin={{ top: 1, bottom: 1 }}>
            * This quote is based on a nominated excess of ${excess}. You can
            change your premium on the next page by choosing a different
            nominated excess.
          </TextSmall>
        )}
      </>
    )}
  </>
);

export { QuotePriceExcessInfo };
